import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { FloatingFocusManager, FloatingPortal, useFloating } from '@floating-ui/react';
import { DimmingLayer } from '../../../../../components/SearchForm/components/WidgetOverlay/components/DimmingLayer.js';
import { Fade } from '../../../../../primitives/index.js';
export const FloatingElement = ({
  open,
  dim = false,
  children
}) => {
  const {
    context
  } = useFloating();
  return _jsxs(FloatingPortal, {
    id: "portal-root",
    children: [dim && open && _jsx(DimmingLayer, {
      lockScroll: true
    }), _jsx(FloatingFocusManager, {
      context: context,
      modal: false,
      initialFocus: -1,
      children: _jsx(Fade, {
        in: open,
        duration: 150,
        children: children
      })
    })]
  });
};